import {InjectionToken} from '@angular/core';

export let APP_CONFIG = new InjectionToken('app.config');

export const SYNTHRONE_CONFIG = {
    appName: 'SYNTHRONE ADMINER',
    version: 1.0,
    api: {
        manager: {
            endpoints: {
                api_get_all_routes: {
                    path: '/system/routes',
                    methods: ['GET']
                }
            }
        },
        crafter: {
            endpoints: {
                api_get_all_routes: {
                    path: '/system/routes',
                    methods: ['GET']
                }
            }
        },
        publisher: {
            endpoints: {
                api_get_all_routes: {
                    path: '/system/routes',
                    methods: ['GET']
                }
            }
        },
        notifications: {
            endpoints: {
                api_add_notification: {
                    path: '/add-notification',
                    methods: ['POST']
                }
            }
        },
        adminer: {
            endpoints: {
                api_get_all_routes: {
                    path: '/system/routes',
                    methods: ['GET']
                },
                api_auth_login: {
                    path: '/login',
                    methods: ['POST']
                }
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/app.config.ts